<template>
  <div class="wrapper shdw col-sm-2">
    <nav id="sidebar">
      <div class="sidebar-header">
        <div class="text-center py-3">
          <a href="#">
            <img
              src="../../assets/Ambee1.png"
              class="img-responsive text-center"
              style="width:200px"
            />
          </a>
        </div>
      </div>
      <div class="list-group text-center" role="tablist">
        <router-link
          v-if="[roleId == 3, roleId == 4]"
          :class="[
            currentPage.includes('apidb') ? navactiveClass : '',
            'list-group-item list-group-item-action mt-2 p-2',
          ]"
          data-toggle="list"
          to="/apidb"
          >Dashboard</router-link
        >
        <router-link
          v-if="[roleId == 3, roleId == 4]"
          :class="[
            currentPage.includes('apiusers') ? navactiveClass : '',
            'list-group-item list-group-item-action mt-2 p-2',
          ]"
          data-toggle="list"
          to="/apiusers"
          >Api Usage</router-link
        >
        <router-link
          v-if="[roleId == 3, roleId == 4]"
          :class="[
            currentPage.includes('nusers') ? navactiveClass : '',
            'list-group-item list-group-item-action mt-2 p-2',
          ]"
          data-toggle="list"
          to="/nusers"
          >New Users</router-link
        >
        <router-link
          v-if="roleId == 3 && email === 'api_admin@getambee.com'"
          :class="[
            currentPage.includes('updatelimit') ? navactiveClass : '',
            'list-group-item list-group-item-action mt-2 p-2',
          ]"
          data-toggle="list"
          to="/updatelimit"
          >Update Limit</router-link
        >
        <router-link
          v-if="roleId == 3"
          :class="[
            currentPage.includes('home') ? navactiveClass : '',
            'list-group-item list-group-item-action mt-2 p-2',
          ]"
          data-toggle="list"
          to="/home"
          >Main menu</router-link
        >
      </div>
    </nav>
    <div class="logout" style="bordertop: 2px solid #dedede">
      <button class="btn logout-btn p-1" @click="logout">
        <i class="fas fa-sign-out-alt" aria-hidden="true"></i>
        Logout
      </button>
    </div>
  </div>
</template>

<script>
import { AUTH_LOGOUT } from "../../store/actions/auth";
export default {
  data() {
    return {
      roleId: parseInt(JSON.parse(localStorage.getItem("user")).roleId),
      email: JSON.parse(localStorage.getItem("user")).email,
      navactiveClass: "activebg",
    };
  },
  computed: {
    currentPage() {
      return this.$route.path;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push("/login"));
    },
  },
};
</script>

<style>
.wrapper {
  height: 100vh;
  position: fixed;
  padding-right: 0px !important;
}
.logout {
  text-align: center !important;
  width: 100%;
  position: absolute;
  bottom: 0;
  right: 0;
}
.logout:hover {
  background-color: #cc0202;
}
.logout-btn {
  font-family: Ubuntu;
  font-weight: 500;
  color: rgba(59, 59, 59, 0.8);
  background-color: transparent;
}
.logout-btn:hover {
  color: white;
}
.activebg {
  background: #2295c8 !important;
  border-radius: 6.5rem 0 0 6.5rem !important;
  color: white;
}
.activebg:hover {
  color: white;
}
</style>